import { DotsVerticalIcon, Trash01Icon } from '@langchain/untitled-ui-icons';
import { ColumnDef } from '@tanstack/react-table';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/Dropdown';
import { TableCellTextOverflow } from '@/components/Table';
import { RuleSchema } from '@/types/schema';

import { isCompositeScoreRule } from '../utils/convertFeedbackFormulaToRule';
import { columnHelper } from './Columns';

export const getEvaluatorActionColumn = (): ColumnDef<RuleSchema, any> => {
  return columnHelper.display({
    id: 'menu_actions',
    cell: ({ row, table }) => {
      const { actions } = (table.options.meta ?? {}) as {
        actions: {
          handleDelete: (id: string, resource: 'rules' | 'formulas') => void;
        };
      };

      const isCompositeScore = isCompositeScoreRule(row.original);

      return (
        <TableCellTextOverflow className="justify-end">
          <DropdownMenu>
            <DropdownMenuTrigger
              onClick={(e) => e.stopPropagation()}
              className="flex h-6 w-6 items-center justify-center rounded-md transition-colors hover:bg-secondary focus:outline-none"
            >
              <DotsVerticalIcon className="h-5 w-5" />
            </DropdownMenuTrigger>

            <DropdownMenuContent
              className="z-10"
              onClick={(e) => e.stopPropagation()}
            >
              <DropdownMenuItem
                onClick={() =>
                  actions.handleDelete(
                    row.original.id,
                    isCompositeScore ? 'formulas' : 'rules'
                  )
                }
                className="flex items-center gap-2"
              >
                <Trash01Icon className="h-5 w-5" />
                Delete
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </TableCellTextOverflow>
      );
    },
    enableSorting: false,
    enableHiding: false,
    enableResizing: false,
    size: 40,
  });
};
